/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiInitiatePasswordResetRequestFromJSON(json) {
    return StreemApiInitiatePasswordResetRequestFromJSONTyped(json, false);
}
export function StreemApiInitiatePasswordResetRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'email': !exists(json, 'email') ? undefined : json['email'],
        'companyCode': !exists(json, 'company_code') ? undefined : json['company_code'],
    };
}
export function StreemApiInitiatePasswordResetRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'email': value.email,
        'company_code': value.companyCode,
    };
}
//# sourceMappingURL=StreemApiInitiatePasswordResetRequest.js.map